// What this browser remembers for the player: the chart's window, the last stake, the multiplier
// per market. Each read and write survives storage that is blocked or empty.

import { createStore, useStore } from "./store";

export type Prefs = {
  /** The live chart's window. */
  range: string;
  /** The stake last played, in dollars as typed. */
  stake: string;
  /** Multiplier last used, per market symbol. */
  leverage: Record<string, number>;
  feedMine: boolean;
};

const KEY = "playertrade:prefs:v1";
const DEFAULTS: Prefs = { range: "15m", stake: "10", leverage: {}, feedMine: false };

function read(): Prefs {
  try {
    const text = localStorage.getItem(KEY);
    return text ? { ...DEFAULTS, ...(JSON.parse(text) as Partial<Prefs>) } : DEFAULTS;
  } catch {
    return DEFAULTS;
  }
}

export const prefs = createStore<Prefs>(read());

prefs.subscribe(() => {
  try {
    localStorage.setItem(KEY, JSON.stringify(prefs.get()));
  } catch {
    // storage blocked: kept for this tab
  }
});

export function setPref<K extends keyof Prefs>(key: K, value: Prefs[K]) {
  prefs.set((all) => ({ ...all, [key]: value }));
}

export function usePref<K extends keyof Prefs>(key: K): Prefs[K] {
  return useStore(prefs, (all) => all[key]);
}
